import React from 'react';

import { defineMessages, useIntl } from 'react-intl';
import { flattenHTMLToAppURL } from '@plone/volto/helpers';
import {
  PageHeader,
  InfoBox,
  RichText,
  PageMetadata,
} from 'iovisit-theme/components/Views';
import Contacts from 'iovisit-theme/components/Blocks/Contacts/Body';

const messages = defineMessages({
  timetable: { id: 'timetable', defaultMessage: 'Orari' },
  accomodationType: {
    id: 'accomodation_type',
    defaultMessage: 'Tipologia di struttura',
  },
  services: {
    id: 'services',
    defaultMessage: 'Servizi',
  },
  contacts: {
    id: 'contacts',
    defaultMessage: 'Contatti',
  },
});

const VocabularyField = ({ title, content }) =>
  content?.length > 0 ? (
    <>
      {title && <h3>{title}</h3>}
      <p>{content.map((t) => t.title).join(', ')}</p>
    </>
  ) : null;

const AccomodationView = ({ content, location }) => {
  const intl = useIntl();

  const timetable = RichText({
    content: content.timetable,
    title: intl.formatMessage(messages.timetable),
    titleTag: 'h3',
  });

  const services = VocabularyField({
    title: intl.formatMessage(messages.services),
    content: content.services,
  });

  const infoBoxHasData = !!timetable;

  return (
    <div id="page-accomodation" className="ui container">
      <PageHeader content={{ ...content, show_share_links: true }} />
      {infoBoxHasData && <InfoBox>{timetable}</InfoBox>}

      {content.accomodation_type && (
        <>
          <h3>{intl.formatMessage(messages.accomodationType)}</h3>
          <p>{content.accomodation_type.title}</p>
        </>
      )}
      {services}

      {content.text?.data?.replace(/(<([^>]+)>)/g, '')?.length > 0 && (
        <>
          <hr />
          <div
            dangerouslySetInnerHTML={{
              __html: flattenHTMLToAppURL(content.text.data),
            }}
          />
        </>
      )}
      <hr />
      <Contacts properties={content} />
      <PageMetadata content={{ ...content, show_modified: true }} />
    </div>
  );
};

export default AccomodationView;
